module.exports = "/static-assets/_next/static/images/img-aefdd31f6f-f1094d1c1d9c268d93bb33e5e5138e09.webp";